<template>
  <v-dialog
    v-model="show"
    max-width="60em"
  >
    <v-card>
      <v-card-title primary-title>
        Add {{ cusip ? cusip.cusip : security }} to folder
      </v-card-title>
      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="4">
            <table class="cusip">
              <tr>
                <td class="label">
                  CUSIP
                </td>
                <td>{{ cusip.cusip }}</td>
              </tr>
              <tr>
                <td class="label">
                  Pool Name
                </td>
                <td>{{ cusip.name }}</td>
              </tr>
            </table>
          </v-col>
          <v-col cols="8">
            <v-select
              v-model="selectedCollectionId"
              :items="collections"
              filled
              label="Folders"
              prepend-inner-icon="mdi-folder-outline"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          outlined
          @click.stop="show = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          outlined
          @click.stop="shownew = true"
        >
          <v-icon>mdi-folder-plus</v-icon>
          Create New Folder
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click.stop="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { getCollections, createCollectionItem } from '@/utils/collections'
export default {
  props: {
    value: Boolean,
    cusip: null
  },
  mounted() {
    this.getCollections()
  },
  methods: {
    getCollections: function() {
      const component = this
      getCollections().then(response => {
        this.collections = response.data.map(coll => {
          return { text: coll.name, value: coll.id }
        })
        if (response.data.length > 0) {
          const mostRecent = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0]
          component.selectedCollectionId = mostRecent.id
        }
      })
    },
    save: function() {
      // do axios here
      const component = this
      const coll = component.selectedCollection
      if (coll) {
        createCollectionItem(component.selectedCollectionId, component.cusip).then(response => {
          component.$emit('update:savedCollection', { id: coll.value, name: coll.text })
          component.show = false
        })
      }
    }
  },
  computed: {
    ...mapState({
      loading: 'loading'
    }),
    selectedCollection: function() {
      return this.collections.find(c => c.value === this.selectedCollectionId)
    },
    shownew: {
      get() {
        return this.showNewFolder
      },
      set(showNewFolder) {
        if (!showNewFolder) {
          this.getCollections()
        }
        this.$emit('update:showNewFolder', showNewFolder)
      }
    },
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    $attrs: function(newAttrs, oldAttrs) {
      if (oldAttrs['show-new-folder'] && !newAttrs['show-new-folder']) {
        // when the show new dialog is hidden, refresh the collection list
        this.getCollections()
      }
    }
  },
  data: () => ({
    showNewFolder: false,
    selectedCollectionId: null,
    collections: []
  })
}
</script>
<style scoped>
td {
  padding: 4px;
}
td.label {
  font-weight: bold;
  text-align: right;
}
</style>
